import React, { createContext, useContext, useState, useEffect } from 'react'
import { API_URL } from 'constants/api'
import { SESS_TOKEN } from 'constants/admin'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem(SESS_TOKEN) ? true : false
    })
    const [error, setError] = useState('')

    const authenticate = async values => {
        try {
            const response = await fetch(`${API_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password: values.pwd }),
            })
            if (response.ok) {
                const data = await response.json()
                localStorage.setItem(SESS_TOKEN, data.token)
                setIsAuthenticated(true)
            } else {
                throw new Error('authentication failed')
            }
        } catch (e) {
            setIsAuthenticated(false)
            setError('general.validation.bad_pwd')
            localStorage.removeItem(SESS_TOKEN)
        }
    }

    const logout = () => {
        localStorage.removeItem(SESS_TOKEN)
        setIsAuthenticated(false)
    }

    return (
        <AuthContext.Provider
            value={{ isAuthenticated, authenticate, logout, error, setIsAuthenticated }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export function useAuthContext() {
    return useContext(AuthContext)
}
